module.exports = __webpack_public_path__ + "img/cloud-upload.e5096c51.svg";